module.exports = __webpack_public_path__ + "img/small.f8ebc196.jpg";